import { EventDispatcher } from "../events/EventDispatcher";
import { LayaGL } from "../layagl/LayaGL";
import { Vector2 } from "../maths/Vector2";
import { Effect2DShaderInit } from "./effect2d/shader/Effect2DShaderInit";
import { CommandBuffer2D } from "./Scene2DSpecial/RenderCMD2D/CommandBuffer2D";
import { SpriteConst, SubPassFlag } from "./SpriteConst";
export class PostProcess2D extends EventDispatcher {
    static init() {
        Effect2DShaderInit.colorEffect2DShaderInit();
        Effect2DShaderInit.blurEffect2DShaderInit();
        Effect2DShaderInit.glow2DShaderInit();
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        if (this._enabled != value) {
            this._enabled = value;
            this._context.command.clear(true);
            this._onChangeRender();
        }
    }
    constructor() {
        super();
        this._effects = [];
        this._enabled = true;
        this._context = { deferredReleaseTextures: [], OriOffset: new Vector2() };
        this._context.compositeShaderData = LayaGL.renderDeviceFactory.createShaderData(null);
        this._context.command = new CommandBuffer2D();
    }
    get owner() {
        return this._owner;
    }
    set owner(value) {
        if (this._owner) {
            this._owner._renderType &= ~SpriteConst.POSTPROCESS;
        }
        this._owner = value;
        if (this._owner) {
            if (this._effects.length > 0 && this._enabled)
                this._owner._renderType |= SpriteConst.POSTPROCESS;
        }
    }
    _onChangeRender() {
        if (this._owner) {
            if (this._effects.length === 0 || !this._enabled) {
                this._owner._renderType &= ~SpriteConst.POSTPROCESS;
            }
            else {
                this._owner._renderType |= SpriteConst.POSTPROCESS;
            }
            this._owner.setSubpassFlag(SubPassFlag.PostProcess);
            this._owner.repaint();
        }
    }
    getEffect(classReg) {
        return this._effects.find(effect => effect instanceof classReg) || null;
    }
    setResource(value) {
        this._context.source = value;
    }
    getDestRT() {
        return this._context.destination;
    }
    get effects() {
        return this._effects;
    }
    set effects(value) {
        this._effects.filter(e => !value.includes(e)).forEach(effect => effect.destroy());
        this._effects.length = 0;
        for (let i = 0, n = value.length; i < n; i++) {
            if (value[i])
                this.addEffect(value[i]);
        }
        this._onChangeRender();
    }
    addEffect(effect) {
        if (effect.singleton && this.getEffect(effect.constructor)) {
            console.error("the target effect is a singleton", effect);
            return null;
        }
        this._effects.push(effect);
        effect.effectInit(this);
        this._onChangeRender();
        return effect;
    }
    removeEffect(effect) {
        effect.destroy();
        let index = this._effects.indexOf(effect);
        if (index !== -1) {
            this._effects.splice(index, 1);
            this._onChangeRender();
        }
    }
    _render() {
        this._context.command.clear(true);
        this._context.indirectTarget = this._context.source;
        this._context.destination = this._context.source;
        for (var i = 0, n = this._effects.length; i < n; i++) {
            let effect = this._effects[i];
            if (effect.active) {
                effect.render(this._context);
                this._context.indirectTarget = this._context.destination;
            }
        }
    }
    clear() {
        this._effects.length = 0;
        this._onChangeRender();
    }
    clearCMD() {
        this._context.command.clear();
    }
    destroy() {
        this.owner = null;
        this._context.compositeShaderData.destroy();
        this._context.compositeShaderData = null;
        this._effects.forEach(effect => effect.destroy());
        this._effects.length = 0;
    }
}
